export default (vertical) => ({vertical});
